<div
    class="tw-flex tw-flex-row tw-h-full tw-w-full tw-max-w-full tw-cursor-pointer hover:tw-shadow-lg tw-transition-shadow tw-duration-300 tw-rounded-[15px] tw-overflow-hidden tw-bg-white tw-shadow-sm"
    (click)="onItemClick()"
    [attr.ga-event-id]="'card_' + slug + '_button_jc3_click'"
    [attr.ga-event-category]="'JC3 Button'"
    [attr.ga-event-label]="'Card Click'"
    ga-track="track"
>
    <div class="carousel-image tw-flex tw-flex-shrink-0">
        <img
            [attr.ga-event-id]="'card_' + slug + '_button_jc3_click'"
            [attr.ga-event-category]="'JC3 Button'"
            [attr.ga-event-label]="'Card Click'"
            ga-track="track"
            [src]="image"
            [alt]="title"
            class="tw-rounded-l-[15px] tw-object-cover tw-h-full tw-w-[296px] sm:tw-w-[296px] md:tw-w-[180px] lg:tw-w-[296px] tw-min-h-[446px] sm:tw-min-h-[446px] md:tw-min-h-[227px] lg:tw-min-h-[296px] xl:tw-block tw-hidden"
        />
        <img
            [attr.ga-event-id]="'card_' + slug + '_button_jc3_click'"
            [attr.ga-event-category]="'JC3 Button'"
            [attr.ga-event-label]="'Card Click'"
            ga-track="track"
            [src]="portrait"
            [alt]="title"
            class="tw-rounded-l-[15px] tw-object-cover tw-h-full tw-w-[296px] sm:tw-w-[296px] md:tw-w-[180px] lg:tw-w-[296px] tw-min-h-[446px] sm:tw-min-h-[446px] md:tw-min-h-[227px] lg:tw-min-h-[296px] xl:tw-hidden md:tw-block tw-hidden"
        />
        <img
            [attr.ga-event-id]="'card_' + slug + '_button_jc3_click'"
            [attr.ga-event-category]="'JC3 Button'"
            [attr.ga-event-label]="'Card Click'"
            ga-track="track"
            [src]="mobile"
            [alt]="title"
            class="tw-rounded-l-[15px] tw-object-cover tw-h-full tw-w-[296px] sm:tw-w-[296px] md:tw-w-[180px] lg:tw-w-[296px] tw-min-h-[446px] sm:tw-min-h-[446px] md:tw-min-h-[227px] lg:tw-min-h-[296px] md:tw-hidden tw-block"
        />
    </div>
    <div
        [attr.ga-event-id]="'card_' + slug + '_button_jc3_click'"
        [attr.ga-event-category]="'JC3 Button'"
        [attr.ga-event-label]="'Card Click'"
        ga-track="track"
        class="tw-flex-1 tw-bg-white tw-pl-[24px] tw-pr-[40px] tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-10"
    >
        <div
            class="tw-flex tw-flex-col tw-items-start tw-justify-center tw-bg-white tw-h-full tw-w-full tw-py-[20px]"
        >
            <span
                class="tw-text-[16px] tw-font-bold tw-text-[#000000CC] tw-mb-[14px]"
                >{{ title }}</span
            >
            <span
                class="tw-text-[14px] tw-leading-[22px] tw-font-normal tw-text-[#000000CC] tw-flex-1 default-html"
                [innerHtml]="shortdesc"
            ></span>
        </div>
    </div>
</div>
